import { render } from "./ThemeSwitch.vue?vue&type=template&id=20eccd2c"
import script from "./ThemeSwitch.vue?vue&type=script&lang=js"
export * from "./ThemeSwitch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__